import React, { forwardRef } from 'react'
import { FormField } from '../FormField'

interface TextAreaProps {
	children: React.ReactNode
	value: string
	onChange: (value: string) => void
	rows?: number
	label?: string
	error?: string
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({ 
	children, 
	value, 
	onChange,
	rows = 4,
	label,
	error,
}, ref) => {
	return (
		<FormField label={label} error={error}>
			<textarea 
				ref={ref}
				className='form-input'
				style={{
					resize: 'none',
					overflow: 'auto',
				}}
				value={value}
				rows={rows}
				onChange={(e) => onChange(e.target.value)}
			>
				{children}
			</textarea>
		</FormField>
	)
})

TextArea.displayName = 'TextArea'